import { render, staticRenderFns } from "./CommentDialog.vue?vue&type=template&id=1a93a264&scoped=true&"
import script from "./CommentDialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./CommentDialog.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CommentDialog.vue?vue&type=style&index=0&id=1a93a264&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a93a264",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog});
